import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { Node } from '../../types/nodes.types';

interface ConfirmDeleteNodeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  node: Node | null;
  deleting: boolean;
  deleteError: string | null;
}

const ConfirmDeleteNodeDialog: React.FC<ConfirmDeleteNodeDialogProps> = ({
  open,
  onClose,
  onConfirm,
  node,
  deleting,
  deleteError,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="error" />
          Confirmar Eliminación
        </Box>
      </DialogTitle>
      <DialogContent>
        {deleteError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {deleteError}
          </Alert>
        )}
        <Typography>
          ¿Está seguro que desea eliminar el nodo <strong>"{node?.name}"</strong>? Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={deleting}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} /> : null}
        >
          {deleting ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteNodeDialog;
